import uuid from "uuid";
import { push } from "connected-react-router";
import { of } from "rxjs";
import { ajax } from "rxjs/ajax";
import { ofType } from "redux-observable";
import { mergeMap, catchError, flatMap } from "rxjs/operators";
import {
	onSafetyPlanChecklistListRequest,
	INFO_SAFETY_PLAN_CHECKLISTS_ROUTE,
} from "features/health-and-safety";
// import { createSitePath, SITE_SAFETY_PLAN_CHECKLIST_PATH } from 'features/sites'
import { ADD_SAFETY_PLAN_CHECKLIST_FORM_SUBMIT } from "../actions/types";
// import { getResponseBody } from '../utils'
import {
	DBService,
	CHECKLIST_TABLE,
	replaceDataURLs,
	authHeaders,
	getOrganisationBaseUrl,
} from "frame";
import { getCurrentTimestamp, isProd } from "utils";
import * as R from "ramda";
import ReactGA from "react-ga";
import {
	onAddSafetyPlanChecklistReset,
	onAddSafetyPlanChecklistSaveFailed,
	onAddSafetyPlanChecklistSaveSuccess,
} from "../actions";

const fetchAttachments = () => async () => {
	const db = new DBService();
	var files = await db.getAll(CHECKLIST_TABLE);
	return files;
};

const addSafetyPlanChecklistEffect = (action$, state$) =>
	action$.pipe(
		ofType(ADD_SAFETY_PLAN_CHECKLIST_FORM_SUBMIT),
		flatMap(fetchAttachments()),
		mergeMap((result) => {
			const spcForm = R.clone(
				state$.value.addSafetyPlanChecklistFormReducer
			);
			const spc = R.clone(
				state$.value.addSafetyPlanChecklistFormReducer.safetyPlan
			);

			const notifiableWorksAttachments =
				Array.isArray(spc.notifiableWorksAttachments)
					? replaceDataURLs(spc.notifiableWorksAttachments, result)
					: [];
			const emergencyPlanAttachments =
				Array.isArray(spc.emergencyPlanAttachments)
					? replaceDataURLs(spc.emergencyPlanAttachments, result)
					: [];
			const attachments =
				Array.isArray(spcForm.attachments)
					? replaceDataURLs(spcForm.attachments, result)
					: [];

			// Normalize declaration other people to API DTO shape
			const declarationOtherPeople = Array.isArray(spc.declarationOtherPeople)
				? spc.declarationOtherPeople
						.filter((p) => p && p.name && String(p.name).trim() !== "")
						.map((p, idx) => ({
							Key: idx + 1,
							Name: String(p.name).trim(),
							Date: p.date ? new Date(p.date) : undefined,
						}))
						.filter((p) => p.Name && p.Date)
				: [];

			const profile = state$.value.profile || {};
			const creatorId =
				profile.userId || profile.id || profile.staffId || "";
			const creatorName =
				profile.fullName ||
				`${profile.firstName || ""} ${profile.lastName || ""}`.trim();

			let body = {
				id: spcForm.id || uuid.v4(),
				siteId: spcForm.siteId,
				createdAt: spcForm.createdAt ? new Date(spcForm.createdAt) : new Date(),
				creatorId: creatorId,
				creatorName: creatorName,
				name: spc.name,

				onSiteSafetyRepresentative: spc.onSiteSafetyRepresentative,
				personInControlOfSite: spc.personInControlOfSite,
				mainPersonInCharge: spc.mainPersonInCharge,
				phone: spc.phone,
				client: spc.client,
				notes: spc.notes,

				// Notifiable Works
				haveNotifiableWorks: spc.haveNotifiableWorks,
				haveAdvisedWorksafeNZ: spc.haveAdvisedWorksafeNZ,
				notificationAttached: spc.notificationAttached,
				notifiableWorksAttachments: notifiableWorksAttachments,

				// Hazard Management
				willMaintainOnSiteHazardRegister:
					spc.willMaintainOnSiteHazardRegister,
				willPrepareTaskAnalysis: spc.willPrepareTaskAnalysis,
				assosicatedWithOtherWorks: spc.assosicatedWithOtherWorks,

				// Communication Employee Participation Frequency
				safetyMinutesFrequency:
					spc.communicationParticipationSafetyMinutesFrequency,
				preTaskPlanningMeetingFrequency:
					spc.communicationParticipationPreTaskPlanningMeetingFrequency,
				inductionMeetingFrequency:
					spc.communicationParticipationInductionMeetingFrequency,

				// Emergencies
				firstAidKitLocation: spc.firstAidKitLocation,
				firstAidPerson: spc.firstAidPerson,
				emergencyPhone: spc.emergencyPhone,
				haveTrainedPersonnelProceduresOnSite:
					spc.haveTrainedPersonnelProceduresOnSite,
				haveAttachedEmergencyPlan: spc.haveAttachedEmergencyPlan,
				willReportToSafetyRepresentative:
					spc.willReportToSafetyRepresentative,
				emergencyPlanAttachments: emergencyPlanAttachments,

				// Accident/Incident
				haveAccidentSystemInPlace: spc.haveAccidentSystemInPlace,
				willImmediatelyNotifyAllAccidents:
					spc.willImmediatelyNotifyAllAccidents,

				// Safety Inspections and Safety Reviews
				undertakeInspection: spc.undertakeInspection,
				otherInspections: spc.otherInspections,

				// Training/Inductions
				allHoldHealthSafetyQualifications:
					spc.allHoldHealthSafetyQualifications,
				allGivenSafetyInduction: spc.allGivenSafetyInduction,
				allAppropriatelyQualified: spc.allAppropriatelyQualified,

				// Declaration
				declarationName: spc.declarationName,
				declarationDate: (() => { try { if (!spc.declarationDate) return new Date(); const d = new Date(spc.declarationDate); if (isNaN(d.getTime()) || d.getFullYear() < 1900) return new Date(); const iso = d.toISOString(); if (iso[0] === '+' || iso[0] === '-') return new Date(); return d; } catch (e) { return new Date(); } })(),
				declarationOtherPeople: declarationOtherPeople,

				// Attachments
				attachments: attachments,

				// Email recipients
				recipients: Array.isArray(spcForm.recipients)
					? spcForm.recipients
					: [],
				recipientsOther: Array.isArray(spcForm.recipientsOther)
					? spcForm.recipientsOther
					: [],
				sendEmail: Boolean(spcForm.sendToRecipientsOnSave),

			// Geo Location
			latitude: state$.value.geolocation?.latitude ?? "",
			longitude: state$.value.geolocation?.longitude ?? "",
				timestamp: getCurrentTimestamp(),
				organisationId: state$.value.organisations.currentOrganisation,
			};

			// Conditionally include approval fields (avoid sending null/invalid values)
			if (spc.approvalName && String(spc.approvalName).trim() !== "") {
				body.approvalName = spc.approvalName;
			}
			if (spc.approvalDate) {
				const approvalDateObj = new Date(spc.approvalDate);
				if (!isNaN(approvalDateObj.getTime())) {
					body.approvalDate = approvalDateObj;
				}
			}

			// Debug logging to inspect request payload
			try {
				const logBody = {
					...body,
					declarationDate:
						body.declarationDate instanceof Date
							? body.declarationDate.toISOString()
							: body.declarationDate,
					approvalDate:
						body.approvalDate instanceof Date
							? body.approvalDate.toISOString()
							: body.approvalDate,
					declarationOtherPeople: Array.isArray(body.declarationOtherPeople)
						? body.declarationOtherPeople.map((p) => ({
							...p,
							Date:
								p && p.Date instanceof Date
									? p.Date.toISOString()
									: p
									? p.Date
									: null,
						}))
						: body.declarationOtherPeople,
				};
				// eslint-disable-next-line no-console
				console.debug("=== SAFETY PLAN CHECKLIST API REQUEST DEBUG ===");
				// eslint-disable-next-line no-console
				console.debug("Full request body:", logBody);
				// eslint-disable-next-line no-console
				console.debug("Declaration section specifically:");
				// eslint-disable-next-line no-console
				console.debug("- declarationName:", body.declarationName);
				// eslint-disable-next-line no-console
				console.debug(
					"- declarationDate:",
					body.declarationDate,
					"(type:",
					typeof body.declarationDate,
					")"
				);
				// eslint-disable-next-line no-console
				console.debug("- declarationOtherPeople:", body.declarationOtherPeople);
				// eslint-disable-next-line no-console
				console.debug("- approvalName:", body.approvalName);
				// eslint-disable-next-line no-console
				console.debug(
					"- approvalDate:",
					body.approvalDate,
					"(type:",
					typeof body.approvalDate,
					")"
				);
				// eslint-disable-next-line no-console
				console.debug("=== END DEBUG ===");
			} catch (e) {
				// eslint-disable-next-line no-console
				console.warn("Failed to log safety plan checklist request body:", e);
			}

			// Build a friendly error message from API model state
			const buildFriendlyErrorMessage = (error) => {
				try {
					const response = error && error.response;

					// 1) If API returned a plain string (e.g. duplicate name message), just show it
					if (typeof response === "string" && response.trim()) {
						return response.trim();
					}

					// 2) If API used ProblemDetails-style payload with title, prefer that
					if (response && typeof response === "object") {
						if (typeof response.title === "string" && response.title.trim()) {
							// If a single "message" field exists, append it
							if (typeof response.message === "string" && response.message.trim()) {
								return `${response.title.trim()}: ${response.message.trim()}`;
							}
							// Otherwise fall through to model-state style parsing below
						}
					}

					const baseMsg =
						(response && (response.error || response.message)) ||
						error.message ||
						"An error occurred";

					const details = response && response.details;
					let messages = [];

					// 3) Flatten any model-state like { field: [ "msg1", "msg2" ], ... }
					if (details && typeof details === "object") {
						Object.keys(details).forEach((key) => {
							const entry = details[key];
							if (Array.isArray(entry)) {
								entry.forEach((msg) => {
									if (typeof msg === "string" && msg.trim()) {
										messages.push(msg.trim());
									}
								});
							} else if (entry && typeof entry === "object") {
								Object.values(entry).forEach((v) => {
									if (Array.isArray(v)) {
										v.forEach((msg) => {
											if (typeof msg === "string" && msg.trim()) {
												messages.push(msg.trim());
											}
										});
									}
								});
							}
						});
					}

					messages = Array.from(new Set(messages));
					const joined = messages.length ? messages.join("\n") : baseMsg;
					return joined;
				} catch (e) {
					return (
						(error &&
							((error.response && error.response.error) ||
								error.message)) ||
						"Bad request"
					);
				}
			};

			return ajax
				.post(
					`${getOrganisationBaseUrl(
						state$.value
					)}/safety-plan-checklist/createorupdate`,
					body,
					authHeaders()
				)
				.pipe(
					mergeMap((ajaxResponse) => {
						isProd &&
							ReactGA.event({
								category: "Tasks",
								action: "Save Clicked",
								label: "Add Site Safety Plan",
							});

						return of(
							onSafetyPlanChecklistListRequest(),
							onAddSafetyPlanChecklistSaveSuccess(),
							onAddSafetyPlanChecklistReset(),
							push(INFO_SAFETY_PLAN_CHECKLISTS_ROUTE)
						);
					}),
					catchError((error) => {
						// eslint-disable-next-line no-console
						console.warn("SPC save failed. Raw error:", error);
						const friendly = buildFriendlyErrorMessage(error);
						// eslint-disable-next-line no-console
						console.warn("SPC save failed. Parsed message:\n" + friendly);
						return of(onAddSafetyPlanChecklistSaveFailed(friendly));
					})
				);
		})
	);

export default addSafetyPlanChecklistEffect;
